import Attachments from "@/views/components/file/attachments";

export const SPULevel = [
  {
    label: "公司级",
    value: true,
  },
  {
    label: "非公司级",
    value: false,
  },
];
export const flowStatus = [
  {
    label: "研发中",
    value: "researching",
  },
  {
    label: "运营中",
    value: "operating",
  },
  {
    label: "已停用",
    value: "closed",
  },
];
export const devStatus = [
  {
    label: "待立项",
    value: "need_approve",
  },
  {
    label: "已立项",
    value: "approved",
  },
  {
    label: "完成典型课评审",
    value: "reviewed",
  },
];
export const devConClusions = [
  { label: "通过", value: "pass" },
  { label: "未通过", value: "not_pass" },
];
export const devConClusionsMap = { pass: "通过", not_pass: "未通过" };
export const trackList = ["成人赛道", "未来技能", "SKU研发", "百词斩", "薄荷芝士派", "早教"];
export const devStages = [
  {
    name: "待立项",
    fields: [
      {
        label: "预计立项时间",
        key: "setupTime",
        render: (h, value, row) => {
          return (
            <div>
              {row.approve_begin_at}-{row.approve_end_at}
            </div>
          );
        },
      },
      {
        label: "预计上市时间",
        key: "marketTime",
        render: (h, value, row) => {
          return (
            <div>
              {row.launch_begin_at}-{row.launch_end_at}
            </div>
          );
        },
      },
      {
        label: "备注",
        key: "remark",
      },
      {
        label: "附件",
        key: "bfiles",
        render: (h, value, row) => {
          return (
            <div>
              <Attachments files={row.bfiles} />
            </div>
          );
        },
      },
    ],
  },
  {
    name: "立项结论",
    bfileKey: "CyaSpuApprove",
    fields: [
      {
        label: "立项结论",
        type: "select_field",
        key: "conclusion",
        cols: 12,
        rules: [(val) => !!val || "必选"],
        required: true,
        items: devConClusions,
        "item-text": "label",
        "item-value": "value",
        render: (h, value) => {
          return <div>{devConClusionsMap[value]}</div>;
        },
      },
      {
        label: "预算预估",
        key: "budget_amount",
        type: "integer_field",
        cols: 12,
        rules: [(val) => !!val || "必选"],
        required: true,
      },
      {
        label: "预计上市时间",
        type: "date_range",
        key: "marketTime",
        start_key: "launch_begin_at",
        end_key: "launch_end_at",
        cols: 12,
        required: true,
        rules: [
          (val) => {
            if (val && val.length < 2) {
              return "需要选择时间段";
            }
            if (val && val.length === 2) {
              return true;
            }
            return "必选";
          },
        ],
        render: (h, v, d) => {
          return (
            <div>
              {d.launch_begin_at
                ? `${d.launch_begin_at}-${d.launch_end_at}`
                : ""}
            </div>
          );
        },
      },
      {
        label: "预计典型课评审时间",
        type: "date_range",
        key: "reviewTime",
        start_key: "review_begin_at",
        end_key: "review_end_at",
        cols: 12,
        required: true,
        rules: [
          (val) => {
            if (val && val.length < 2) {
              return "需要选择时间段";
            }
            if (val && val.length === 2) {
              return true;
            }
            return "必选";
          },
        ],
        render: (h, v, d) => {
          return (
            <div>
              {d.review_begin_at
                ? `${d.review_begin_at}-${d.review_end_at}`
                : ""}
            </div>
          );
        },
      },
      {
        label: "备注",
        key: "remark",
        type: "text_field",
        cols: 12,
      },
      {
        label: "附件",
        key: "bfiles",
        cols: 12,
        render: (h, value, row) => {
          return (
            <div>
              <Attachments files={row.bfiles} />
            </div>
          );
        },
      },
    ],
  },
  {
    name: "典型课评审结论",
    bfileKey: "CyaSpuReview",
    fields: [
      {
        label: "评审结论",
        type: "select_field",
        key: "conclusion",
        cols: 12,
        rules: [(val) => !!val || "必选"],
        required: true,
        items: devConClusions,
        "item-text": "label",
        "item-value": "value",
        render: (h, value) => {
          return <div>{devConClusionsMap[value]}</div>;
        },
      },
      {
        label: "预算预估",
        key: "budget_amount",
        type: "integer_field",
        cols: 12,
        rules: [(val) => !!val || "必选"],
        required: true,
      },
      {
        label: "预计上市时间",
        type: "date_range",
        // key: "marketTime",
        start_key: "launch_begin_at",
        end_key: "launch_end_at",
        cols: 12,
        required: true,
        rules: [
          (val) => {
            if (val && val.length < 2) {
              return "需要选择时间段";
            }
            if (val && val.length === 2) {
              return true;
            }
            return "必选";
          },
        ],
        render: (h, v, d) => {
          return (
            <div>
              {d.launch_begin_at
                ? `${d.launch_begin_at}-${d.launch_end_at}`
                : ""}
            </div>
          );
        },
      },
      {
        label: "备注",
        key: "remark",
        type: "text_field",
        cols: 12,
      },
      {
        label: "附件",
        key: "bfiles",
        cols: 12,
        render: (h, value, row) => {
          return (
            <div>
              <Attachments files={row.bfiles} />
            </div>
          );
        },
      },
    ],
  },
  {
    name: "上市结论",
    bfileKey: "CyaSpuLaunch",
    fields: [
      {
        label: "上市结论",
        type: "select_field",
        key: "conclusion",
        cols: 12,
        rules: [(val) => !!val || "必选"],
        required: true,
        items: devConClusions,
        "item-text": "label",
        "item-value": "value",
        render: (h, value) => {
          return <div>{devConClusionsMap[value]}</div>;
        },
      },
      {
        label: "上市时间",
        type: "date_picker_v1",
        key: "launch_begin_at",
        cols: 12,
        required: true,
        rules: [(val) => !!val || "必选"],
      },
      {
        label: "备注",
        key: "remark",
        type: "text_field",
        cols: 12,
      },
      {
        label: "附件",
        key: "bfiles",
        cols: 12,
        render: (h, value, row) => {
          return (
            <div>
              <Attachments files={row.bfiles} />
            </div>
          );
        },
      },
    ],
  },
];

export const SPU_TYPE = [
  {
    label: '虚拟',
    value: 1
  },
  {
    label: '实体',
    value: 2
  }
]

export const SPU_VERSION_TYPE = [
  {
    label: '新增',
    value: 1
  },
  {
    label: '迭代',
    value: 2
  }
]

export const SPU_SELECT_SPLITER = "@###@"